import styled from '@emotion/styled/macro'
import { Box } from '@mui/material'
import theme from 'theme'

export const Wrapper = styled(Box)<{ align?: string; darkBg?: string; isCategory?: string }>`
  position: static;
  padding: ${theme.spacing.medium}px ${theme.spacing.medium}px 0;
  top: 100px;
  width: -webkit-fill-available;
  width: -moz-available;
  width: -ms-available;
  min-height: 100px;
  z-index: 1001;
  display: flex;
  background: ${({ darkBg }) => (darkBg && darkBg === 'true' ? `${theme.colors.primaryDark}` : 'transparent')};
  align-items: ${({ align }) => (align ? 'flex-end' : ' center')};

  ${({ isCategory }) =>
    isCategory &&
    isCategory === 'true' &&
    `
    padding: 16px 24px;
    min-height: unset;
    
    .MuiTabs-root {
      .MuiTabs-scroller {
        .MuiTabs-flexContainer {
          .MuiButtonBase-root.MuiTab-root {
            color: #A18A9D;
            font-family: ${theme.typography.fontFamily.primary};
            font-size: ${theme.typography.fontSize.xLarge};
            font-style: normal;
            font-weight: ${theme.typography.fontWeight.bold};
            line-height: 24px;
            letter-spacing: 0.1px;
            margin-right: ${theme.spacing.xLarge}px;
            
            &.Mui-selected {
              color: ${theme.colors.textPrimary};
            }
          }
        }
      }
    }
  `};
`
